"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAuditDecisionRequestDtoDecisionEnum = void 0;
exports.instanceOfDocumentAuditDecisionRequestDto = instanceOfDocumentAuditDecisionRequestDto;
exports.DocumentAuditDecisionRequestDtoFromJSON = DocumentAuditDecisionRequestDtoFromJSON;
exports.DocumentAuditDecisionRequestDtoFromJSONTyped = DocumentAuditDecisionRequestDtoFromJSONTyped;
exports.DocumentAuditDecisionRequestDtoToJSON = DocumentAuditDecisionRequestDtoToJSON;
exports.DocumentAuditDecisionRequestDtoToJSONTyped = DocumentAuditDecisionRequestDtoToJSONTyped;
/**
 * @export
 */
exports.DocumentAuditDecisionRequestDtoDecisionEnum = {
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
};
/**
 * Check if a given object implements the DocumentAuditDecisionRequestDto interface.
 */
function instanceOfDocumentAuditDecisionRequestDto(value) {
    if (!('decision' in value) || value['decision'] === undefined)
        return false;
    return true;
}
function DocumentAuditDecisionRequestDtoFromJSON(json) {
    return DocumentAuditDecisionRequestDtoFromJSONTyped(json, false);
}
function DocumentAuditDecisionRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'decision': json['decision'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'emailMessage': json['emailMessage'] == null ? undefined : json['emailMessage'],
    };
}
function DocumentAuditDecisionRequestDtoToJSON(json) {
    return DocumentAuditDecisionRequestDtoToJSONTyped(json, false);
}
function DocumentAuditDecisionRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'decision': value['decision'],
        'notes': value['notes'],
        'emailMessage': value['emailMessage'],
    };
}
//# sourceMappingURL=DocumentAuditDecisionRequestDto.js.map